import { useSelector } from "react-redux";

const Mobile: React.FC = () => {
  const retry = () => {
    window.location.href = "https://www.anten.ir";
  };

  const { tvMobileHelper, tvMobileButton } = useSelector(
    (state: any) => state.ConfigState?.config?.appSetting?.language
  );

  return (
    <main className="offline">
      <div>
        <h3 style={{ lineHeight: 1.7 }}>
          {tvMobileHelper ||
            "برای مشاهده آنتن از طریق تلفن همراه، گزینه زیر را انتخاب کنید"}
        </h3>
        <span className="btn" onClick={retry}>
          {tvMobileButton || "ورود به آنتن"}
        </span>
      </div>
    </main>
  );
};

export default Mobile;
